import Vue from 'vue';
import Router from 'vue-router';

import MitUserModel from '../models/MitUserModel.js';
import MitUserService from '../services/MitUserService.js';


import MitLandingPage from '../pages/MitLandingPage.vue';
import MitNoAccessPage from '../pages/MitNoAccessPage.vue';

//USER
import MitMyKeysPage from '../pages/user/MitMyKeysPage.vue';

//MANAGER - reports
import MitManageReportsLowInventoryPage from '../pages/manager/MitManageReportsLowInventoryPage.vue';
//MANAGER - manage
import MitManageKeysPage from '../pages/manager/MitManageKeysPage.vue';
import MitManageBorrowedPage from '../pages/manager/MitManageBorrowedPage.vue';
//MANAGER - actions
import MitBorrowKeyPage from '../pages/manager/MitBorrowKeyPage.vue';
import MitReturnKeyPage from '../pages/manager/MitReturnKeyPage.vue';
import MitLostKeyPage from '../pages/manager/MitLostKeyPage.vue';

//ADMIN
import MitAdminPage from '../pages/admin/MitAdminPage.vue';


Vue.use(Router);

const routerGuardAccessCheck = (to, from, next) => {

  MitUserService.getUser()
    .then((user) => {
      if (user && user.role >= to.meta.allowedRole ) {
        //Add current user and role options to the page
        to.params.userModel = user;
        to.params.userRoles = MitUserModel.ROLES;
        next();
      } else {
        //Redirect to OIDC login.
        //TODO: FIGURE OUT HOW TO PASS a param to get back to where the user was originally going.
        //window.location.href = '/auth/provider';
        next({ name: "landing"});
      }
    })
    .catch((error) => {
      console.log('An error occurred trying to get signed in user', error);
      next({ name: "no-access"});
    });
}


let routes = [
  {
    path: '/landing',
    name: 'landing',
    component: MitLandingPage
  },
  {
    path: '/my/keys',
    name: 'my-keys',
    component: MitMyKeysPage,
    meta: { allowedRole: MitUserModel.ROLES.USER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/manage/reports/keys/lowinventory',
    name: 'manage-reports-keys-lowinventory',
    component: MitManageReportsLowInventoryPage,
    meta: { allowedRole: MitUserModel.ROLES.MANAGER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/manage/keys',
    name: 'manage-keys',
    component: MitManageKeysPage,
    meta: { allowedRole: MitUserModel.ROLES.MANAGER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/manage/borrowed',
    name: 'manage-borrowed',
    component: MitManageBorrowedPage,
    meta: { allowedRole: MitUserModel.ROLES.MANAGER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/borrow',
    name: 'borrow',
    component: MitBorrowKeyPage,
    meta: { allowedRole: MitUserModel.ROLES.MANAGER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/return',
    name: 'return',
    component: MitReturnKeyPage,
    meta: { allowedRole: MitUserModel.ROLES.MANAGER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/lost',
    name: 'lost',
    component: MitLostKeyPage,
    meta: { allowedRole: MitUserModel.ROLES.MANAGER },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: MitAdminPage,
    meta: { allowedRole: MitUserModel.ROLES.ADMIN },
    props: true,
    beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
    }
  },
  {
    path: '/noaccess',
    name: 'no-access',
    component: MitNoAccessPage,
  },
  {
    path: '*',
    //redirect: { name: 'landing' },
    beforeEnter(to, from, next) {
      MitUserService.getUser()
        .then((user) => {
          //If the user is logged in go home
          if (user ) {
            //Add current user and role options to the page
            to.params.userModel = user;
            to.params.userRoles = MitUserModel.ROLES;
            next({ name: "my-keys"})
          }
          //else send to landing page
          else {
            next({ name: "landing"});
          }
        })
        .catch((error) => {
          console.log('An error occurred trying to get signed in user', error);
          next({ name: "landing"});
        });
    }
  },
];

export default new Router({
  routes,
  mode: 'history'
});
